import {
  NewMultilegDefaultDelta1Behaviour,
  type NewMultilegDefaultDelta1Behaviour as NewMultilegDefaultDelta1BehaviourValue,
} from '@src/providers/TradingSettingsContext.types';
import type { Security } from '@talos/kyoko';
import { MultilegComboType } from '../enums';
import type { LegsContainer } from '../models';
import {
  applyDelta1Leg2Defaulting,
  type Delta1AutoOpenCell,
  type Delta1Leg2DefaultingResult,
} from './Delta1Leg2Defaulting';

export interface NewMultilegDefaultingContext {
  behaviour: NewMultilegDefaultDelta1BehaviourValue;
  getTradableMarketAccountNames?: (security: Security) => string[];
}

export interface NewMultilegDefaultingInput extends NewMultilegDefaultingContext {
  customLegs: LegsContainer;
}

export interface NewMultilegDefaultingResult {
  customLegs: LegsContainer;
  autoOpenCell?: Delta1AutoOpenCell;
}

interface NewMultilegDefaultingStrategy {
  supports: (input: NewMultilegDefaultingInput) => boolean;
  apply: (input: NewMultilegDefaultingInput) => Delta1Leg2DefaultingResult;
}

const newMultilegDefaultingStrategies: NewMultilegDefaultingStrategy[] = [
  {
    supports: input => input.customLegs.instrumentType === MultilegComboType.Delta1Spread,
    apply: input =>
      applyDelta1Leg2Defaulting({
        customLegs: input.customLegs,
        behaviour: input.behaviour,
        getTradableMarketAccountNames: input.getTradableMarketAccountNames,
      }),
  },
];

export function applyNewMultilegDefaulting(input: NewMultilegDefaultingInput): NewMultilegDefaultingResult {
  if (input.behaviour === NewMultilegDefaultDelta1Behaviour.None) {
    return { customLegs: input.customLegs };
  }

  const strategy = newMultilegDefaultingStrategies.find(candidate => candidate.supports(input));
  return strategy?.apply(input) ?? { customLegs: input.customLegs };
}
